var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.706.896h17.588C23.341.896 25 2.513 25 4.506v12.1c0 1.81-1.368 3.309-3.151 3.57a.566.566 0 0 0-.496.55v1.383c0 .884-1.098 1.327-1.74.702l-1.37-1.335a4.477 4.477 0 0 0-3.122-1.26H3.706C1.659 20.216 0 18.6 0 16.606v-12.1C0 2.513 1.66.896 3.706.896Z",
    fill: "#00ff40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.478 5.875H4.521v1.373h15.957V5.875Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.478 9.267H4.521v1.372h15.957V9.267Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.478 12.658H7.772v1.373h12.706v-1.373Z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20.478,
    y1: 6.561,
    x2: 4.522,
    y2: 6.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B395F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#37355A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#171B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 20.478,
    y1: 9.953,
    x2: 4.522,
    y2: 9.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B395F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#37355A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#171B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 20.478,
    y1: 13.345,
    x2: 7.772,
    y2: 13.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B395F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#37355A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#171B35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.74a2a11a9181ed8be7587a9baf9b249b.svg";
export { ForwardRef as ReactComponent };